import React from "react";
import {
  Document,
  Font,
  Image,
  Page,
  Text,
  StyleSheet,
} from "@react-pdf/renderer";

import RobotoBold from "fonts/Roboto-Bold.ttf";
import RobotoBlack from "fonts/Roboto-Black.ttf";

Font.register({
  family: "Roboto",
  fonts: [
    { src: RobotoBold, fontWeight: 700 },
    { src: RobotoBlack, fontWeight: 900 },
  ],
});

const StickerProductPackage = ({ data }) => (
  <Document>
    {Array(data.quantity)
      .fill(null)
      .map((a, i) => (
        <Page
          key={i}
          size={{ width: 377.95275591, height: 566.92913386 }}
          style={styles.page}
        >
          <Text style={styles.sku}>{data.sku}</Text>
          <Image
            src={data.image_base64}
            style={{
              width: 160,
              height: 160,
              marginBottom: 20,
            }}
          />
          <Image
            src={data.qr_code_base64}
            style={{
              width: 100,
              height: 100,
              marginBottom: 20,
            }}
          />
          <Text style={styles.name}>{data.name}</Text>
        </Page>
      ))}
  </Document>
);

const styles = StyleSheet.create({
  page: {
    backgroundColor: "#fff",
    padding: 20,
    alignItems: "center",
  },
  sku: {
    fontFamily: "Roboto",
    fontSize: 20,
    fontWeight: 900,
    marginBottom: 20,
    color: "#000",
    textAlign: "center",
  },
  name: {
    fontFamily: "Roboto",
    fontWeight: 600,
    fontSize: 35,
    color: "#000",
    textAlign: "center",
  },
});

export default StickerProductPackage;
